const state = {
    showVerticalMenu: false,
    menuRoutes: '',

    currentDate: null,
    dateActivityDuration: 0,

    hasError: false,
    errorMessage: '',

    filterOptions: {},
    filters: {
        accountingFirmUser: 0,
    },

    viewAllTimeSheets: false,
    showDashboard: false,
    isBiller: false,

    type: '',
    pageCode: '',
}

const mutations = {
    SET_VIEW_ALL_TIME_SHEETS(state, viewAllTimeSheets) {
        state.viewAllTimeSheets = viewAllTimeSheets
    },

    SET_SHOW_DASHBOARD(state, showDashboard) {
        state.showDashboard = showDashboard
    },

    SET_IS_BILLER(state, isBiller) {
        state.isBiller = isBiller
    },

    SET_DATE_ACTIVITY_DURATION(state, dateActivityDuration) {
        state.dateActivityDuration = dateActivityDuration
    },

    SET_CURRENT_DATE(state, currentDate) {
        state.currentDate = currentDate
    },

    SET_MENU_ROUTES(state, menuRoutes) {
        state.menuRoutes = menuRoutes
    },

    SET_ERROR(state, message) {
        state.hasError = true
        state.errorMessage = message
    },

    RESET_ERROR(state) {
        state.hasError = false
        state.errorMessage = ''
    },

    SET_TYPE(state, type) {
        state.type = type
    },

    RESET_TYPE(state) {
        state.type = ''
    },

    SET_PAGE_CODE(state, pageCode) {
        state.pageCode = pageCode
    },

    RESET_PAGE_CODE(state) {
        state.pageCode = ''
    },

    SHOW_VERTICAL_MENU(state) {
        state.showVerticalMenu = true
    },

    HIDE_VERTICAL_MENU(state) {
        state.showVerticalMenu = false
    },

    SET_ACCOUNTING_FIRM_USER_OPTION(state, option) {
        state.filters.accountingFirmUser = option
    },
}

const actions = {
    async getRoutes({ commit }) {
        try {
            const response = await axios.get('/time-sheets/routes')
            commit('SET_MENU_ROUTES', response.data)
        } catch (error) {
            // console.log(error)
            console.log('menuRoutes not loaded !')
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
